module.exports = __webpack_public_path__ + "img/noti6.6d6dc69f.jpg";